export const ENDPOINT_ID = 'endpoint';

const Endpoint = ({ id = ENDPOINT_ID }) => {
  return <div id={id} style={{ height: 0 }} />;
};

export default Endpoint;
